/**
 * Persister — Turn CC · 14.
 *
 * Wires a synchronous localStorage persister to the shared QueryClient.
 * Applied at the AppShell root via PersistQueryClientProvider so any
 * cached query survives full page reloads. Result: after the first login,
 * every subsequent refresh paints the last snapshot INSTANTLY, then
 * silently revalidates in the background.
 *
 * Key rules:
 *   - Buster string bumps when the shape of a query changes so stale
 *     serialisations are dropped rather than corrupting the UI.
 *   - `maxAge` capped at 24 h — anything older is discarded on load so a
 *     laptop that slept for a week doesn't hydrate a week-old brief.
 *   - We do NOT persist mutations (`dehydrateOptions`) — mutations only
 *     live in-memory.
 */
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const localStoragePersister =
  typeof window !== "undefined"
    ? createSyncStoragePersister({
        storage: window.localStorage,
        key: "hm-rq-cache",
        throttleTime: 300,
        // Small hardening so a corrupt entry never breaks first paint.
        serialize: (v) => {
          try { return JSON.stringify(v); } catch { return "{}"; }
        },
        deserialize: (s) => {
          try { return JSON.parse(s); } catch { return undefined; }
        },
      })
    : undefined;

// Cache buster — bump when a query shape changes (list endpoints, etc.).
export const CACHE_BUSTER = "cc14-v1";

// 24h max age.
export const MAX_AGE_MS = 24 * 60 * 60 * 1000;
